export default __webpack_public_path__ + "static/media/AntDesign.163adab9.ttf";